(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["katapult-script"] && !Shopify.designMode) return;
  try {
    const isStaging = window.location.hostname === 'staging-brandsmart.myshopify.com';

  var _katapult_config = {
    api_key: isStaging
      ? window.KATAPULT_SETTINGS.stagingApiKey
      : window.KATAPULT_SETTINGS.productionApiKey,
    environment: isStaging
      ? window.KATAPULT_SETTINGS.stagingEnvironment
      : window.KATAPULT_SETTINGS.productionEnvironment
  };

  !function(e,t){e.katapult=e.katapult||{};var n,i,r;i=!1,n=document.createElement("script"),n.type="text/javascript",n.async=!0,n.src=t.environment+"/"+"plugin/js/katapult.js",n.onload=n.onreadystatechange=function(){i||this.readyState&&"complete"!=this.readyState||(i=!0,e.katapult.setConfig(t.api_key))},r=document.getElementsByTagName("script")[0],r.parentNode.insertBefore(n,r);var s=document.createElement("link");s.setAttribute("rel","stylesheet"),s.setAttribute("type","text/css"),s.setAttribute("href",t.environment+"/"+"plugin/css/katapult.css");var a=document.querySelector("head");a.insertBefore(s,a.firstChild)}(window,_katapult_config);
  
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.btn-katapult-price-calculator').forEach((item) => {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        var calcData = {
          is_click_on_pre_approve: e?.target?.classList?.contains('katapult-price-calculator-pre-approve')
        }
        katapult.loadPriceCalculator(calcData);
      })
    })
  })
  } catch(e) { console.error(e); }
})();

})();
